import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  HomeIcon,
  MagnifyingGlassIcon,
  ArrowLeftIcon,
} from '@heroicons/react/24/outline';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="container-custom text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          {/* 404 Visual */}
          <div className="relative mb-8">
            <div className="text-[200px] md:text-[300px] font-bold leading-none bg-gradient-to-r from-primary-500/20 to-accent-500/20 bg-clip-text text-transparent select-none">
              404
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-32 h-32 md:w-48 md:h-48 rounded-full bg-gradient-to-r from-primary-500 to-accent-500 opacity-20 blur-3xl" />
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <h1 className="text-3xl md:text-4xl font-bold mb-4">
              Page Not Found
            </h1>
            <p className="text-gray-400 text-lg mb-8 max-w-md mx-auto">
              Oops! The page you're looking for doesn't exist or has been moved.
              Let's get you back on track.
            </p>

            {/* Quick Links */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
              <Link
                to="/"
                className="btn-primary flex items-center space-x-2 px-8"
              >
                <HomeIcon className="h-5 w-5" />
                <span>Go Home</span>
              </Link>
              <Link
                to="/auctions"
                className="btn-secondary flex items-center space-x-2 px-8"
              >
                <MagnifyingGlassIcon className="h-5 w-5" />
                <span>Browse Auctions</span>
              </Link>
            </div>

            {/* Popular Pages */}
            <div className="glass-card p-8 max-w-2xl mx-auto">
              <h2 className="text-xl font-semibold mb-6">Popular Pages</h2>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[
                  { label: 'Live Auctions', href: '/auctions' },
                  { label: 'Collections', href: '/collections' },
                  { label: 'Staking', href: '/staking' },
                  { label: 'Governance', href: '/governance' },
                  { label: 'Leaderboard', href: '/leaderboard' },
                  { label: 'Fractional', href: '/fractional' },
                  { label: 'Tokenomics', href: '/tokenomics' },
                  { label: 'Create Auction', href: '/auctions/create' },
                ].map((link) => (
                  <Link
                    key={link.href}
                    to={link.href}
                    className="p-3 rounded-lg bg-dark-700/50 hover:bg-dark-700 text-gray-400 hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Back Button */}
            <button
              onClick={() => window.history.back()}
              className="mt-8 text-gray-400 hover:text-white flex items-center space-x-2 mx-auto transition-colors"
            >
              <ArrowLeftIcon className="h-4 w-4" />
              <span>Go Back</span>
            </button>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFoundPage;
